import { useMemo } from 'react'

import { useAllAuctionLabelsQuery } from '../../graphql/generated'
import { useAppSelector } from '../../redux/hooks'

/**
 * fetching auction label IDs
 * Filters only labels that have at least 1 connection with auction
 *
 * @returns {Object} - {data, fetching, error}
 * @returns {string[]} returns.data - Array of label IDs, or [''] if no labels are found
 *
 */
export const useAuctionLabelIds = () => {
  const accountId = useAppSelector(state => state.myProfile.tenantId)

  const [allLabels] = useAllAuctionLabelsQuery({
    variables: {
      accountId: accountId,
    },
    pause: !accountId,
  })

  const labelIds = useMemo(() => {
    const labels = allLabels.data?.allLabels?.nodes?.reduce((acc, label) => {
      if (
        (label?.labelConnectionsByLabelId?.totalCount || 0) > 0 &&
        label?.id
      ) {
        acc.push(label.id)
      }
      return acc
    }, [] as string[])
    return labels || []
  }, [allLabels.data?.allLabels?.nodes])

  return {
    data: labelIds,
    fetching: allLabels.fetching,
    error: allLabels.error,
  }
}
